import { textStyles, typography } from '../constants';
import { create } from './ThemedStyleSheet';

/**
 * Some themed stylesheets ready to be used in components
 */
export const themedFonts = create({
    ...typography,
    ...textStyles,

    text: () => ({ color: 'var(--sp-color-text-base)' }),
    textMid: (theme) => ({ color: theme.colors.text.mid }),
    textMuted: () => ({ color: 'var(--sp-color-text-muted)' }),
    textLight: () => ({ color: 'var(--sp-color-text-light)' }),
    textStandout: (theme) => ({ color: theme.colors.text.standout }),
    textInverted: (theme) => ({ color: theme.colors.text.inverted }),
    textSidebar: (theme) => ({ color: theme.colors.sidebar.itemText }),
    textSidebarItem: (theme) => ({ color: theme.colors.sidebar.itemText }),
    textSidebarMutedItem: (theme) => ({ color: theme.colors.sidebar.mutedItemText }),
    textSidebarActiveItem: (theme) => ({ color: theme.colors.sidebar.activeItemText }),
    textSidebarPrimary: (theme) => ({ color: theme.colors.info.hovered }),
    textSidebarStandout: (theme) => ({ color: theme.colors.sidebar.standoutText }),
    primaryMid: (theme) => ({ color: theme.colors.primary.mid }),
    primary: (theme) => ({ color: theme.colors.text.primary }),
    primaryStandout: (theme) => ({ color: theme.colors.primary.standout }),
    textInsideColor: (theme) => ({ color: theme.colors.info.textInside }),
    merge: (theme) => ({ color: theme.colors.merge.main }),
    success: (theme) => ({ color: theme.colors.success.main }),
    upgrade: (theme) => ({ color: theme.colors.upgrade.main }),
    danger: (theme) => ({ color: theme.colors.danger.main }),
    warning: (theme) => ({ color: theme.colors.warning.main }),
    info: (theme) => ({ color: theme.colors.info.main }),
});
